import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";
import { UserAvatar } from "components/user-avatar";

import "./styles.scss";

import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState, useRef } from "react";
import { useModal } from "context/ModalContext";
import { RegulamentoFooter } from "components/regulamento-footer";
import {
  getAllLotteries,
  getParticipantes,
  getRewardItem,
  getMyNumbers,
  getWinners,
} from "services/lottery.service";
import moment from "moment";
import "moment/locale/pt-br";
import { FaTimesCircle } from "react-icons/fa";
import Modal from "react-modal";

moment.locale("pt-br");

export function Sorteio() {
  Modal.setAppElement("#modal");
  
  const modalContent = useRef<HTMLDivElement>(null);
  const { user } = useAuth();
  const { showModal } = useModal();
  const [lotteries, setLotteries] = useState<any>([]);
  const [lotterieDetail, setLotterieDetail] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [participantes, setParticipantes] = useState<any>([]);
  const [ganhadores, setGanhadores] = useState<any>([]);
  const [catalogItems, setCatalogItems] = useState<any>([]);

  const [loadingWinners, setLoadingWinners] = useState<boolean>(false);
  const [loadingParticipantes, setLoadingParticipantes] = useState<boolean>(false);
  const [showDetail, setShowDetail] = useState<boolean>(false);  
  const [hasNumbers, setHasNumbers] = useState<boolean>(false);
  const [luckyNumbers, setLuckyNumbers] = useState<any>([]);
  const [lotteryId, setLotteryId] = useState<string>();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  function openModal() {}

  function afterOpenModal() {}

  function closeModal() {
    setIsOpen(false);
  }

  async function loadData() {
    setLoading(true);

    const data = await getRewardItem();
    setCatalogItems(data);

    const data1 = await getAllLotteries();
    setLotteries(data1);
    setLoading(false);
  }

  useEffect(() => {
    if (!user) return;
    loadData();
  }, [user]);

  const returnReward = (item: any) => {
    let text = "";
    if (item.type === 0) {
      let point = "";
      if(item.item === "star"){
        point = "Estrela";
      } else if(item.item === "giro"){
        point = "Grio";
      } else if(item.item === "brb_points"){
        point = "Mundo BRB";
      }
      text = " Ponto(s) - " + point;
    } else if (item.type === 2) {
      const reward = catalogItems.filter((e: any) => e._id === item.item)[0];
      text = " Prêmio - " + reward ? reward.name : "undefined";
    }
    return text;
  };

  const handleDetail = (state: boolean, lotterie?: any) => {
    setShowDetail(state);

    if(lotterie){
      setLotterieDetail(lotterie);

      setLotteryId(lotterie._id);

      setLoadingParticipantes(true);
  
      getParticipantes(lotterie._id)
      .then((res) => {
        setParticipantes(res);

        const userTemNumero = res.some((e: any) => user?._id === e._id);
        setHasNumbers(userTemNumero);
      })
      .catch((error) => {
        console.error("Erro ao buscar participantes:", error);
      })
      .finally(() => {
        setLoadingParticipantes(false);
      });

  
      if (lotterie.executedDate !== null) {
        setLoadingWinners(true);
        getWinners(lotterie._id).then(function (res) {
          setGanhadores(res);
          setLoadingWinners(false);
        });
      }
    }
  };

  const handleMyLuckyNumbers = () => {    
    getMyNumbers(lotteryId, user?._id).then(function (res) {
      setLuckyNumbers(res);
    }).finally(function(){
      setIsOpen(true);
    });
  }

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center space-y-0">
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div className="bg-[#F2F2F2] w-screen text-black md:-mx-10 bgShadow p-5">
            <div className="w-full md:w-[1200px] mx-auto" id="sorteios">
              <h2>
                <strong>Sorteio(s)</strong>
              </h2>
              {loading && <h3>Carregando...</h3>}
              {!loading && lotteries && (
                <>
                  {!showDetail && (
                    <ul className="listItems grid md:grid-cols-3">
                      {lotteries.map((item: any, index: number) => (
                        <li key={item._id} className="max-w-[500px] p-3 border">
                            <div className="image">
                              <img
                                className="max-w-[100%] block mx-auto"
                                src={item.image}
                                alt=""
                              />
                            </div>
                            <div className="content">
                              <h3>{item.title}</h3>
                              <p className="mb-5">{item.description}</p>
                              <button
                                type="button"
                                onClick={() => handleDetail(true, item)}
                              >
                                DETALHES -&gt;
                              </button>
                            </div>
                        </li>
                      ))}
                    </ul>
                  )}
                  {showDetail && (
                    <div>
                      <div>
                        <button
                          className="float-right text-[2.4em]"
                          type="button"
                          onClick={() => handleDetail(false)}
                        >
                          <FaTimesCircle />
                        </button>
                        <h3>{lotterieDetail.title}</h3>
                        <p className="mb-5">{lotterieDetail.description}</p>
                        <p>
                          A ser realizado dia:{" "}
                          <strong>
                            {moment(lotterieDetail.drawDate).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </strong>
                        </p>
                        <p>
                          Número de ganhadores para este sorteio:{" "}
                          <strong>{lotterieDetail.maxWinners}</strong>
                        </p>
                        {lotterieDetail.executedDate && (
                          <p>
                            Sorteio realizado:{" "}
                            <strong>
                              {moment(lotterieDetail.executedDate).format(
                                "DD/MM/YYYY HH:mm"
                              )}
                            </strong>
                          </p>
                        )}
                        <p className="mt-5">Prêmio(s) deste sorteio:</p>
                        <ul className="list-disc">
                          {lotterieDetail && lotterieDetail.rewards.length > 0 && (
                            <>
                              {lotterieDetail.rewards.map(
                                (item: any, index: number) => (
                                  <li key={`item${index}`}>
                                    <p className="uppercase">
                                      <strong>{item.total} {returnReward(item)}</strong>
                                    </p>
                                  </li>
                                )
                              )}
                            </>
                          )}
                          {lotterieDetail.rewards.length === 0 && 
                            <li><p>Prêmio não definido</p></li>
                          }
                        </ul>
                        {hasNumbers && (
                          <button onClick={() => handleMyLuckyNumbers()} className="bg-[#88e1f2] text-[#072e92] text-center py-1 md:px-4 md:py-2 mt-5 font-bold">VER MEU(S) NÚMERO(S) DA SORTE</button>
                        )}
                      </div>
                      <div className="flex">
                        <div className="w-1/2 p-4">
                          <h3 className="mt-5">Participantes do sorteio:</h3>
                          <ul className="list-disc">
                            {participantes &&
                              participantes.map((item: any) => (
                                <li key={item._id} className="mb-3">
                                  <p>
                                    <span className={`uppercase ${item._id === user._id ? "font-bold": ""}`}>
                                      {item.name}
                                    </span>{" "}
                                    - (total de tickets {item.total})
                                    {item._id === user._id && (
                                      <span className="font-bold"> &lt;- VOCÊ</span>
                                    )}
                                  </p>
                                </li>
                              ))}
                          </ul>
                          {loadingParticipantes && <p>Carregando...</p>}
                        </div>
                        <div className="w-1/2 p-4">
                          <h3 className="mt-5">Ganhador(es) do sorteio:</h3>
                          {!loadingWinners && ganhadores && (
                            <ul>
                              {ganhadores.map((item: any) => (
                                <li key={item._id} className="mb-3">
                                  <p className="flex items-center ">
                                    <div className="w-[40px] h-[40px] mr-2">
                                      <UserAvatar
                                        data={{ ...item, ...item?.extra }}
                                        responsive={true}
                                      />
                                    </div>
                                    <span className="uppercase">
                                      {item.name}
                                    </span>
                                  </p>
                                </li>
                              ))}
                            </ul>
                          )}
                          {!loadingWinners && ganhadores.length === 0 && (
                            <p>O sorteio ainda não foi realizado</p>
                          )}
                          {loadingWinners && <p>Carregando...</p>}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {!loading && lotteries.length === 0 && <h3 className="text-center mb-10">Sem nenhum sorteio no momento.</h3>}
            </div>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            portalClassName="relative z-[600]"
            overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
            contentElement={() => (
              <div className="modalDetailBox " ref={modalContent}>
                <h2>Meus números da sorte</h2>

                <ul className="list-disc">
                  {luckyNumbers.map(
                    (item: any, index: number) => (
                      <li key={`item${index}`}>
                        <p className="uppercase">
                          <strong>{item._id}</strong>
                        </p>
                      </li>
                    )
                  )}
                </ul>
                <button
                  onClick={closeModal}
                  aria-label="Fechar modal"
                  tabIndex={0}
                  className="closeModal flex border py-2 px-4 mx-auto rounded-full my-4 text-[1.5em] text-white"
                >
                  X
                </button>
              </div>
            )}
          />
        </div>
        <RegulamentoFooter />
      </div>
      <Outlet />
    </>
  );
}
